module.exports = __webpack_public_path__ + "static/media/maestro.bacf608b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/gopay/maestro.png
// module id = 483
// module chunks = 0